var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24.4 24.4",
    style: {
      enableBackground: "new 0 0 24.4 24.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M20.7,3.8c-2.3-2.3-5.3-3.5-8.5-3.5C9,0.2,6,1.5,3.7,3.8c-4.7,4.7-4.7,12.3,0,16.9c2.3,2.3,5.3,3.5,8.5,3.5 c3.2,0,6.2-1.2,8.5-3.5c2.3-2.3,3.5-5.3,3.5-8.5C24.2,9,22.9,6,20.7,3.8z M10.6,6.1c0-0.6,0.2-1,0.5-1.4c0.3-0.3,0.7-0.5,1.2-0.5 c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.4,0.8,0.4,1.3v7.1c0,0.6-0.2,1-0.4,1.3c-0.6,0.6-1.8,0.6-2.4,0c-0.3-0.3-0.5-0.7-0.5-1.3V6.1z  M13.6,20.2c-0.8,0.7-1.9,0.7-2.7,0.1c-0.3-0.2-0.6-0.7-0.6-1.5c0-0.6,0.2-1.1,0.6-1.5c0.4-0.3,0.8-0.5,1.4-0.5c0.5,0,1,0.2,1.4,0.5 c0.4,0.4,0.6,0.9,0.6,1.5C14.2,19.4,14,19.8,13.6,20.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/Exclamation.c47fb5f4.svg";
export { ForwardRef as ReactComponent };